import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"
import moment from "moment";
import logo from "../assets/Logo.svg";
import Notification from "./common/notification";
import UserContext from "../context/userContext";
import NotificationContext from "../context/notificationContext";
import SidebarContext from "../context/sidebarContext";
import "../App.css";

moment.updateLocale("en", {
  calendar: {
    sameElse: "Do MMM YYYY h:mm A",
  },
});

const RenderDropdownIcon = ({ notificationCount }) => {
  return (
    <React.Fragment>
      <i className="fas fa-bell"></i>
      {notificationCount > 0 && (
        <span className="badge badge-primary ml-1">
          {notificationCount <= 10 ? notificationCount : "10+"}
        </span>
      )}
    </React.Fragment>
  );
};

const NavBar = ({ handleSiteClick }) => {
  const [user] = useContext(UserContext);
  const { notifications, handleRead } = useContext(NotificationContext);
  // const [appearance, setAppearance] = useContext(AppearanceContext);
  const [sidebar, setSidebar] = useContext(SidebarContext);

  const displayNotifications = notifications.slice(0, 7);

  const getEnv = () => {
    if (!process.env.REACT_APP_MY_ENV) return;
    const env = process.env.REACT_APP_MY_ENV;
    if (env === "DEV") return "Development";
    if (env === "SAND") return "Sandbox";
    if (env === "LOCAL") return "Localhost";
    return "";
  };
  
  return (
    <nav className="navbar navbar-expand-xxl navbar-dark bg-dark navbar-container">
      {user ? (
        <button
          className="btn btn-link text-white"
          style={{ width: "45px" }}
          onClick={() => setSidebar(!sidebar)}
        >
          {sidebar ? (
            <i className="fas fa-chevron-left" />
          ) : (
            <i className="fas fa-bars" />
          )}
        </button>
      ) : null}
      <Link className="navbar-brand" to="/">
        <img
          className="img-fluid"
          src={logo}
          alt="British Sugar Logo"
          width="130"
        />
        <span className="sitename">{user && `${user.LONG_SITE} ${getEnv()}`}</span>
      </Link>
      <Navbar
        collapseOnSelect
        expand="sm"
        className="navbar-dark nav-fill navbarMenu">
        <Navbar.Toggle aria-controls="navbarMenu" data-bs-target="#navbarMenu" className="navbarMenu" />
        <Navbar.Collapse id="navbarMenu">
          <Nav className="navbarItems">
            <form className="d-flex">
            {!user && (
              <NavLink className="nav-item nav-link" to="/login">
                Login
              </NavLink>
            )}
            {user && (
              <React.Fragment>
                <li
                  className="nav-item nav-link"
                  style={{ cursor: "pointer" }}
                  onClick={handleSiteClick}
                >
                  <i className="fas fa-industry" />
                </li>
                <NavDropdown
                  title={
                    <RenderDropdownIcon
                      notificationCount={
                        notifications.filter((n) => !n.IS_READ).length
                      }
                    />
                  }
                  id="notification-dropdown"
                >
                  {displayNotifications.map((note) => (
                    <Notification
                      key={note.ID}
                      id={note.ID}
                      title={note.HEADING + ` ${note.SITE}`}
                      body={note.MESSAGE}
                      timestamp={moment(note.CREATED_DTS).calendar()}
                      read={note.IS_READ}
                      handleRead={handleRead}
                      link={note.LINK}
                    />
                  ))}
                  <div className="d-flex w-100 justify-content-between">
                    <Link to="/notifications" className="btn btn-link btn-sm">
                      <small>All Notifications</small>
                    </Link>
                    <Link
                      to="/profile/subscriptions"
                      className="btn btn-link btn-sm"
                    >
                      <small>Manage Subscriptions</small>
                    </Link>
                  </div>
                </NavDropdown>
                <NavLink className="nav-item nav-link" to="/profile">
                  <i className="fas fa-user-circle"></i>{" "}
                  {user.FIRST_NAME !== "" || user.FIRSTNAME !== null
                    ? user.FULL_NAME
                    : user.USERNAME}
                </NavLink>
                <NavLink className="nav-item nav-link" to="/help">
                  <i className="fas fa-info-circle" /> Help
                </NavLink>
                <NavLink className="nav-item nav-link" to="/logout">
                  Sign Out
                </NavLink>
              </React.Fragment>
            )}
            </form>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </nav>
  );
};

export default NavBar;
